/* Flayvr V5.22: approved V20 renderer, live D1 vectors and extracted REC-V3 matcher.
 * No demo rankings, no inferred prices, dish names, media or romance scores.
 */
(function(){
'use strict';
const BASE='https://flayvr-taste-intelligence.samueldontoh.workers.dev/v1/restaurants/vectors';
const root=document.getElementById('flayvr-guide-content');
const loading=document.getElementById('flayvr-guide-loading');
const cfg=window.FLAYVR_GUIDE_PRODUCTION||{};
function fail(message){if(loading){loading.hidden=false;loading.style.display='block';loading.textContent=message;loading.setAttribute('role','alert');}if(root){root.hidden=true;root.style.setProperty('display','none','important');}}
function siblingAsset(name){const current=document.currentScript||Array.from(document.scripts).find(s=>s.src.includes('flayvr-guide-dynamic-bootstrap-v522.js'));return current?.src?.replace('flayvr-guide-dynamic-bootstrap-v522.js',name)||'';}
function loadAsset(name){return new Promise((res,rej)=>{const s=document.createElement('script');s.src=siblingAsset(name);s.onload=res;s.onerror=()=>rej(Error('Unable to load '+name));document.body.append(s);});}
/* FLAYVR_GUIDE_V524_PROFILE_REPAIR: recover existing profile across all 3 tabs */
function queryProfile(){
 const qs=new URLSearchParams(location.search);
 function fromSession(key){try{return sessionStorage.getItem('flayvr_journey_'+key)||''}catch(e){return''}}
 let raw=qs.has('tp_axes')?(qs.get('tp_axes')||''):(qs.has('p')?'':fromSession('tp_axes'));
 let axes=raw.split(',').map(Number);
 if(axes.length!==6||!axes.every(x=>Number.isInteger(x)&&x>=0&&x<=100)){
  const token=qs.has('p')?(qs.get('p')||''):(qs.has('tp_axes')?'':fromSession('p'));
  const codec=window.TasteProfileCodecV173;
  const decoded=token&&codec?.decode?.(token);
  if(decoded){axes=['adv','heat','intensity','acid','texture','sweet'].map(k=>decoded[k]);}
 }
 if(axes.length!==6||!axes.every(x=>Number.isInteger(x)&&x>=0&&x<=100))return null;
 try{sessionStorage.setItem('flayvr_journey_tp_axes',axes.join(','))}catch(e){}
 const behaviour=qs.get('tp_b')||fromSession('tp_b');let b=null;
 if(/^1[0-4][0-4][0-9a-z]{2}[0-5]$/.test(behaviour)){
  const mask=parseInt(behaviour.slice(3,5),36);b={v:1,snack:parseInt(behaviour[1],36),heatStyle:parseInt(behaviour[2],36),pull:[],turnOff:parseInt(behaviour[5],36)};
  for(let i=0;i<6;i++)if(mask&(1<<i))b.pull.push(i);
 }
 return {axes,b};
}
const axisNames=['adventure','heat','intensity','acid','texture','sweet'];
function validVector(r){return r&&typeof r.restaurant_id==='string'&&r.restaurant_id&&typeof r.name==='string'&&r.name&&(!r.canonical_restaurant_id||r.canonical_restaurant_id===r.restaurant_id)&&(!r.status||r.status==='ready')&&r.approved!==false&&(!Number.isFinite(Number(r.google_rating??r.googleRating??r.google?.rating))||Number(r.google_rating??r.googleRating??r.google?.rating)===0||Number(r.google_rating??r.googleRating??r.google?.rating)>=4.2)&&(!r.expires_at||Date.parse(r.expires_at)>Date.now())&&axisNames.every(k=>Number.isInteger(r.taste?.[k])&&r.taste[k]>=0&&r.taste[k]<=100);}
function essence(r,profile){
 const keys=['adv','heat','intensity','acid','texture','sweet'];
 const diffs=keys.map(k=>({key:k,diff:Math.abs(profile[k]-(r[k]||0))})).sort((a,b)=>a.diff-b.diff);
 const labels={adv:'adventure',heat:'heat',intensity:'intensity',acid:'brightness',texture:'texture',sweet:'sweetness'};
 return `Closest on ${labels[diffs[0].key]} and ${labels[diffs[1].key]}; compare all six axes to see where your tastes differ.`;
}
function verifiedMenuUrl(r){const sources=Array.isArray(r.sources)?r.sources:[];const source=sources.find(x=>x?.kind==='official_menu'&&/^https:\/\//.test(x.url||''));return source?.url||'';}
function verifiedMenuDishes(r){
 const source=verifiedMenuUrl(r);if(!source)return [];
 const input=Array.isArray(r.menu_dishes)?r.menu_dishes:[];
 return input.filter(x=>x&&typeof x==='object'&&typeof x.name==='string'&&x.name.trim()&&x.verified!==false&&(!x.source_url||x.source_url===source)).slice(0,8).map(x=>({name:x.name.trim(),description:String(x.description||'').trim(),verified:true,source}));
}
function rankAndShape(raw,profile){
 const fn=window.FLAYVR_REC_V3_SOURCE?.fit;
 if(typeof fn!=='function')throw Error('Existing Taste Profile scoring source unavailable');
 const prof=Object.fromEntries(axisNames.map((k,i)=>[k==='adventure'?'adv':k,profile.axes[i]]));
 const byId=new Map();
 for(const r of raw){if(!validVector(r))continue;const id=r.restaurant_id;if(!byId.has(id))byId.set(id,r);}
 if(!byId.size)throw Error('No eligible, six-axis-scored restaurants in the current feed');
 const ranked=[...byId.values()].map(r=>{
  const p={adv:r.taste.adventure,heat:r.taste.heat,intensity:r.taste.intensity,acid:r.taste.acid,texture:r.taste.texture,sweet:r.taste.sweet};
  const exact=fn(p,prof,profile.b).palate;
  return {r,p,exact};
 }).sort((a,b)=>b.exact-a.exact||a.r.name.localeCompare(b.r.name,'en-GB')||a.r.restaurant_id.localeCompare(b.r.restaurant_id));
 const restaurants=ranked.map(({r,p,exact},i)=>({
  id:r.restaurant_id,name:r.name,area:r.area||'',cuisine:r.cuisine||'',address:r.address||'',
  axes:axisNames.map(k=>r.taste[k]),score:Math.round(exact),scoreExact:exact,rank:i+1,
  // V20 requires a numeric price. Zero is an explicit 'unknown' sentinel; patches hide its display and filtering.
  p:0,priceVerified:false,dining:r.dining||null,diningEvidence:r.dining_evidence||null,priceTier:(Number.isInteger(r.priceTier)&&r.priceTier>=1&&r.priceTier<=4?r.priceTier:undefined),date:[],vibe:[],desc:essence(p,prof),why:essence(p,prof),
  tag:'Six-axis taste match',menuSource:verifiedMenuUrl(r),dishes:verifiedMenuDishes(r),
  evidenceSources:(Array.isArray(r.sources)?r.sources:[]).filter(x=>/^https:\/\//.test(x?.url||''))
 }));
 return {restaurants,profile:{name:'Your Taste Profile',summary:'Matched using your existing six taste axes.',headline:'Your flavour profile',axes:profile.axes.slice()},
  calibration:{verified:true,profileAxesVersion:'FLAYVR-REC-V3.0',venueAxesVersion:'FLAYVR-REC-V3.0',rankingVersion:'FLAYVR-REC-V3.0 · six-axis match'},
  catalogStats:{activeUniqueScored:restaurants.length,verified:true},liveSource:'flayvr-taste-intelligence/v1/restaurants/vectors'};
}

/* FLAYVR_PRICE_FROM_EXISTING_TASTE_PROFILE_V1 — sourced display prices only.
 * Price bands and published ranges are indicative, not verified restaurant averages.
 * No changes to REC-V3 rankings or six taste axes. */
function flayvrJoinTastePrices(feed){
 const idx=window.FLAYVR_GUIDE_TASTE_PRICE_INDEX_V1;
 if(!idx || !idx.groups) return;
 const normal=s=>String(s||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/&/g,' and ').replace(/[^a-z0-9]+/gi,' ').trim().toLowerCase();
 for(const v of feed.restaurants){
  const group=idx.groups[normal(v.name)]||[];
  if(!group.length)continue;
  // Only exact unique name, or exact name with unambiguous area / postcode.
  const area=normal(v.area),addr=normal(v.address);
  let matches=group.filter(x=>x.area && (x.area===area || addr.includes(x.area)) || x.postcode && addr.includes(x.postcode));
  if(matches.length===0 && group.length===1)matches=group;
  if(matches.length!==1)continue;
  const x=matches[0];
  v.flayvrPriceBand=x.price.band;
  v.flayvrPriceRange=x.price.range;
  v.flayvrPriceOrigin='Existing Flayvr Taste Profile catalogue';
 }
 window.FLAYVR_TASTE_PRICE_JOIN_V1={feedCount:feed.restaurants.length,priced:feed.restaurants.filter(v=>v.flayvrPriceBand||v.flayvrPriceRange).length,catalogue:idx.rowCount};
}
function flayvrInstallTastePriceDisplay(){
 const root=document.querySelector('.flayvr-guide-root');
 if(!root)return;
 const venues=window.FLAYVR_RESTAURANT_GUIDE_DATA?.restaurants||[];
 const normal=s=>String(s||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/&/g,' and ').replace(/[^a-z0-9]+/gi,' ').trim().toLowerCase();
 const byId=new Map(venues.map(v=>[String(v.id),v]));
 const byName=new Map();for(const v of venues){const k=normal(v.name);if(!byName.has(k))byName.set(k,v);else byName.set(k,null);}
 const lookFor=/Spend not verified|No spend (?:information|info)|Spend (?:unavailable|information unavailable|not available)|Price (?:unavailable|not verified)/gi;
 const draw=()=>{
  for(const card of root.querySelectorAll('#top3 > *,#top17 > *,#moreMatches > *')){
   const id=card.dataset.flayvrVenueId||card.dataset.restaurantId||card.dataset.venueId||card.dataset.id;
   const h=card.querySelector('h3,h2');const v=byId.get(String(id))||byName.get(normal(h?.textContent));
   if(!v || !(v.flayvrPriceBand||v.flayvrPriceRange))continue;
   const label=[v.flayvrPriceBand,v.flayvrPriceRange].filter(Boolean).join(' · ');
   const walker=document.createTreeWalker(card,NodeFilter.SHOW_TEXT),nodes=[];let t;
   while(t=walker.nextNode())if(lookFor.test(t.textContent||'')){nodes.push(t);lookFor.lastIndex=0;}
   for(const node of nodes){node.textContent=node.textContent.replace(lookFor,label);lookFor.lastIndex=0;}
  }
 };
 draw(); for(const id of ['top3','top17','moreMatches']){
  const el=root.querySelector('#'+id);if(el)new MutationObserver(()=>requestAnimationFrame(draw)).observe(el,{childList:true});
 }setTimeout(draw,700);setTimeout(draw,2000);
}

async function start(){
 try{
  const search=new URLSearchParams(location.search);
  // No full profile link = invitation, even if an unrelated session had previous scores.
  const explicitProfile=search.has('p')||search.has('tp_axes');
  const profile=explicitProfile?queryProfile():null;
  if(!profile){await loadAsset('flayvr-guide-entry-v1.js');return;}
  await loadAsset('flayvr-guide-tpv-score-v522.js');
  const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),15000);
  let response;try{response=await fetch(BASE,{headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal});}finally{clearTimeout(timer);}
  if(!response.ok)throw Error('Taste Intelligence responded with '+response.status);
  const data=await response.json();if(!Array.isArray(data?.restaurants))throw Error('Unexpected Taste Intelligence feed response');
  await loadAsset('flayvr-guide-taste-prices-v1.js');
  /* FLAYVR_FULL_D1_360PLUS_V1: append only canonical, eligible D1 vectors missing from current Worker response; preserve original source ranking and price index. */
  await loadAsset('flayvr-guide-vector-supplement-v1.js');
  const snapshot=window.FLAYVR_GUIDE_VECTOR_SUPPLEMENT_V1;
  if(!snapshot || !Array.isArray(snapshot.restaurants) || snapshot.restaurants.length<360)throw Error('D1 Guide supplement unavailable');
  const existingIds=new Set(data.restaurants.map(v=>String(v.restaurant_id)));
  const allLiveVectors=data.restaurants.concat(snapshot.restaurants.filter(v=>!existingIds.has(String(v.restaurant_id))));
  const feed=rankAndShape(allLiveVectors,profile);
  window.FLAYVR_FULL_D1_360PLUS_AUDIT={workerCount:data.restaurants.length,snapshotCount:snapshot.restaurants.length,combinedCount:feed.restaurants.length,generatedAt:snapshot.generatedAt};
  flayvrJoinTastePrices(feed);
  // FLAYVR_OCCASION_V4: a separate D1 evidence layer. Never changes taste axes or match percentages.
  try{
    const occUrl=BASE.slice(0,BASE.lastIndexOf('/'))+'/occasions';
    const occController=new AbortController(); const occTimer=setTimeout(()=>occController.abort(),8000);
    let occResponse;try{occResponse=await fetch(occUrl,{headers:{Accept:'application/json'},cache:'no-store',signal:occController.signal});}finally{clearTimeout(occTimer);}
    if(!occResponse.ok)throw Error('Occasion feed '+occResponse.status);
    const occasion=await occResponse.json();
    if(occasion?.version!=='occasion-v4'||typeof occasion.restaurants!=='object')throw Error('Invalid occasion response');
    for(const v of feed.restaurants){const row=occasion.restaurants[String(v.id)];v.occasionEvidence=Array.isArray(row?.occasions)?row.occasions:[];
      v.date=v.occasionEvidence.map(x=>String(x.code||'')).filter(Boolean);}
    window.FLAYVR_OCCASION_FEED_V4=true;
  }catch(e){console.warn('Flayvr occasion feed not yet available:',e);window.FLAYVR_OCCASION_FEED_V4=false;}

  window.FLAYVR_RESTAURANT_GUIDE_DATA=feed;
  window.FLAYVR_GUIDE_SETTINGS={cardImageHeightDesktop:cfg.cardHeightDesktop,cardImageHeightMobile:cfg.cardHeightMobile,dateImageHeightDesktop:cfg.dateHeightDesktop,dateImageHeightMobile:cfg.dateHeightMobile};
  window.FLAYVR_GUIDE_APPEARANCE={heroImageUrl:cfg.heroImageUrl};
  await loadAsset('flayvr-guide-v18.js');
  flayvrInstallTastePriceDisplay();if(root)root.hidden=false;if(loading)loading.hidden=true;await loadAsset('flayvr-guide-filter-repair-v524.js');
  await loadAsset('flayvr-guide-photos-v523.js');
  /* FLAYVR_ISLINGTON_EDITORIAL_V1: approved D1 intake shown separately, never ranked as REC-V3. */
  /* FLAYVR_ANGEL_MY_LISTS_CACHE_SCOPE_V4: My Lists is a GUIDE HASH VIEW, not a directory.
     A previous Angel asset inherited the BOOTSTRAP query version, so Safari could keep an old carousel.
     Use the VERIFIED Angel V3 file's own cache version. Do not modify REC-V3, list data or other asset URLs. */
  try{
    const angelFile='flayvr-guide-islington-v1.js';
    const angelUrl=new URL(siblingAsset(angelFile),location.href);
    angelUrl.searchParams.set('v','1793164801');
    angelUrl.searchParams.set('fv_angel','39d64695a16fec42265c23cd3d21d9e2');
    await new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=angelUrl.href;
      script.onload=resolve;
      script.onerror=()=>reject(Error('Unable to load verified Angel Guide directory'));
      document.body.appendChild(script);
    });
    /* Remove obsolete V1 carousel if older Safari code inserted it on this navigation. */
    const orphan=document.getElementById('flayvr-islington-editorial');
    if(orphan)orphan.remove();
  }catch(editorialError){
    const orphan=document.getElementById('flayvr-islington-editorial');
    if(orphan)orphan.remove();
    console.warn('Islington editorial unavailable',editorialError);
  }
 }catch(e){console.error('Flayvr Guide V5.22:',e);fail('Restaurant data is currently unavailable: '+String(e?.message||'Unknown data error')+'. Your saved Taste Profile is unchanged.');}
}
window.FLAYVR_GUIDE_V522_TEST={queryProfile,validVector,rankAndShape};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
